const estimate = {
  namespaced:true,
  state: () => ({
    dataDictionary: {},
    energy: {code:'',field:'',name:''},
    phosphorus: {code:'',field:'',name:''},
    aminoAcid: {code:'',field:'',name:''},
    setPredictionType: '',
    weightData: {min: 0,max: 1000},  //饲喂程序体重区间
    lactationLength: 21,  //保存哺乳天数
  }),
  mutations:{
    setDataDictionary(state, action){
      state.dataDictionary =  action
    },
    setSystemName(state, action){
      let field = ''
      if(action.field === 'energySystem') field = 'energy'
      if(action.field === 'aminoAcidSystem') field = 'aminoAcid'
      if(action.field === 'phosphorusSystem') field = 'phosphorus'
      if(field) state[field] = action
    },
    setState(state, payload) {
      for (let i in payload) {
        state[i] = payload[i]
      }
    },
  }
}

export default estimate